import React from "react";

import { useTheme, Statistics, IconPanel, Grid } from "@tiny/components";
import { SegmentDetailsView } from "@tiny/api";
import Group from "@tiny/icons/generated/Group";
import MailOpen from "@tiny/icons/generated/MailOpen";
import ErrorOutline from "@tiny/icons/generated/ErrorOutline";
import CursorDefaultClickOutline from "@tiny/icons/generated/CursorDefaultClickOutline";
import {
  formatNumber,
  formatPercent,
} from "@tiny/components/src/utils/formatUtils";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";

type AudienceDetailsStatisticsProps = {
  segmentDetails?: SegmentDetailsView;
  all?: boolean;
};

function AudienceDetailsStatistics(props: AudienceDetailsStatisticsProps) {
  const { segmentDetails, all } = props;

  const theme = useTheme();

  const { mdUp, lgUp } = useBreakpoints();

  return (
    <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 2}>
      <Grid item xs={mdUp ? 12 : 6} md={3}>
        <IconPanel
          icon={<Group />}
          color={theme.palette.primary.main}
          hasBorderRadius={mdUp}
        >
          <Statistics
            value={formatNumber(segmentDetails?.numberOfCustomers) || undefined}
            title="Customers"
            info={
              all
                ? "Total customers"
                : "The number of unique and active customers in this audience."
            }
          />
        </IconPanel>
      </Grid>
      <Grid item xs={mdUp ? 12 : 6} md={3}>
        <IconPanel
          icon={<MailOpen />}
          color={theme.palette.primary.main}
          hasBorderRadius={mdUp}
        >
          <Statistics
            value={formatPercent(segmentDetails?.openProgress)}
            title="Open rate"
            info={`Average open rate among all the active customers in ${
              all ? "all audiences" : "this audience"
            }. Higher the better.`}
          />
        </IconPanel>
      </Grid>
      <Grid item xs={mdUp ? 12 : 6} md={3}>
        <IconPanel
          icon={<CursorDefaultClickOutline />}
          color={theme.palette.primary.main}
          hasBorderRadius={mdUp}
        >
          <Statistics
            value={formatPercent(segmentDetails?.clickedProgress)}
            title="Click rate"
            info={`Average click rate among all the active customers in ${
              all ? "all audiences" : "this audience"
            }. Higher the better.`}
          />
        </IconPanel>
      </Grid>
      <Grid item xs={mdUp ? 12 : 6} md={3}>
        <IconPanel icon={<ErrorOutline />} color={theme.palette.error.main}>
          <Statistics
            value={formatPercent(segmentDetails?.unsubscribedProgress)}
            title="Unsubscribe rate"
            info={`Average unsubscribe rate among all the active customers in ${
              all ? "all audiences" : "this audience"
            }. Lower the better.`}
          />
        </IconPanel>
      </Grid>
    </Grid>
  );
}

export default AudienceDetailsStatistics;
